export default "__VITE_ASSET__DqSzmydb__"